export function getAvailableLuxPlusInclusionsForMembers(
  luxPlusInclusionsByTier: App.LuxPlusInclusionsByTier | undefined,
  inclusionsViewableLuxPlusTier: App.MembershipSubscriptionTier,
  hasLuxPlusOrSubscriptionInCart: boolean,
): Array<App.PackageInclusion> {
  if (!hasLuxPlusOrSubscriptionInCart || !luxPlusInclusionsByTier) {
    return []
  }

  return luxPlusInclusionsByTier[inclusionsViewableLuxPlusTier] || []
}

export function buildEvergreenPackageInclusions(
  evergreenInclusions: Array<App.EvergreenInclusion>,
): Array<App.PackageInclusion> {
  return evergreenInclusions.map((inclusion) => ({
    id: inclusion.id,
    description: inclusion.description,
    symbol: 'key',
    isHighlighted: true,
  }))
}

export function buildAllStandardInclusions(
  evergreenInclusions: Array<App.EvergreenInclusion> | undefined,
  standardInclusions: Array<App.PackageInclusion>,
  tileInclusions: Array<App.OfferInclusion> | undefined,
): Array<App.PackageInclusion> {
  const evergreenPackageInclusions = buildEvergreenPackageInclusions(evergreenInclusions || [])
  const flashOfferInclusions = tileInclusions || []

  return [
    ...evergreenPackageInclusions,
    ...standardInclusions,
    ...flashOfferInclusions,
  ].map((inclusion, index) => {
    const isHighlighted = index === 0 || inclusion.isHighlighted

    const symbol = inclusion.symbol || (isHighlighted ? 'tag' : undefined)
    return {
      ...inclusion,
      symbol,
      isHighlighted,
    }
  }) as Array<App.PackageInclusion>
}
